<h2 matDialogTitle>Nueva versión disponible</h2>
<section matDialogContent>
  <p>
    Hay una nueva versión disponible de la aplicación y es necesario tener la ultima versión
    instalada. Pulsa el botón <strong>actualizar</strong> para confirmar este paso.
  </p>
  <app-message type="info"
    >Cuando aceptes la actualización, la aplicación se recargará para instalar la nueva versión.
    Este proceso puede tardar unos segundos.</app-message
  >
</section>
<footer matDialogActions align="end">
  <button mat-raised-button color="primary" type="button" (click)="confirm()">
    <mat-icon>browser_updated</mat-icon>
    <span>Actualizar</span>
  </button>
</footer>
